export enum ConsultingPath {
  WITH_PLANER = "WITH_PLANNER", // 동행
  NON_CONTACT = "NON_CONTACT", // 비동행
  BOTH = "BOTH", // 상관없음
}

export enum ConsultingType {
  CONTACT = "CONTACT",
  NON_CONTACT = "NON_CONTACT",
}

export interface ConsultingApply {
  customerUuid?: string;
  inpath: ConsultingPath | null;
  funnel?: string;
  consultingApplyType: ConsultingType;
  customer: ConsultingCustomer;
  visitDt?: string;
  content?: string;

  // 추가
  partnerUuid?: string;
  region?: string; // "1", "2" .... 지역 코드
  wedDt?: string; // 결혼 예정일
  minBudget?: number | null;
  maxBudget?: number | null;

  // 추가2
  interest?: string;

  // 추가3
  referer?: string;
}

export enum CustomerRole {
  BRIDE = "BRIDE",
  GROOM = "GROOM",
}

export interface ConsultingCustomer {
  role: CustomerRole;
  name: string;
  tel: string;
  mateName: string;
  mateTel: string;
}

export interface ConsultingRegion {
  code: string;
  name: string;
}

export interface ConsultingLatestApply {
  id: number;
  customerId: number;
  consultingApplyType: string;
  inPath: string;
  visitDt: string;
  role: string;
  name: string;
  tel: string;
  mateName: string;
  mateTel: string;
  content: string;
  adminId: string;
  regTsp: string;
  partnerUuid: string;
  region: number;
  minBudget: number;
  maxBudget: number;
  interest: string;
}

export interface IResPreviousConsultingApplyInfo {
  customerId: number;
  customerUuid: string;
  consultingApplyType: string | null;
  inpath: string | null;
  interest: string | null;
  visitDt: string | null;
  wedDt: string | null;
  minBudget: number | null;
  maxBudget: number | null;
  customer: {
    mateName: string | null;
    mateTel: string | null;
    name: string | null;
    role: string | null;
    tel: string | null;
  };
  content: string | null;
  region: string | null;
}
